import React, { Component } from "react";
import "./SampleAadharPopup.scss";
import combineAadhar from "../../../assets/docSampleImages/combineAadharSample.jpg";
import borderLine from "../../../assets/Line 9.svg";
import AadharFront from "../../../assets/docSampleImages/Aadhar-Front-Sample.jpg";
import AadharBack from "../../../assets/docSampleImages/Aadhar-Back-Sample.jpg";
export interface IViewSampleAadharPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
  style?: any;
}
const SampleAadharPopup = (props: IViewSampleAadharPopup) => {
  const [readMore, setReadMore] = React.useState<boolean>(false);
  const openAadharNewTab = () => {
    window.open("https://uidai.gov.in/en", "_blank");
  };
  const popupRefTwo = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (popupRefTwo.current !== null && popupRefTwo.current !== undefined) {
        props?.setShowPopup(); // Close popup if clicked outside
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);
  return (
    <div
      className={`overlay-Aadhar ${props?.parentClassName ?? ""}`}
      ref={popupRefTwo}
    >
      <div className="popup-Aadhar">
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={(e) => {
            if (props?.setShowPopup !== undefined) props?.setShowPopup(false);
          }}
        >
          <i className="edel-icon-close" />
        </button>

        <h2 className="popup-title">Uploading Aadhaar Card Formats</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}
        <div className="Aadhar-format-1">
          <span>
            <label className="Aadhar-format-1-title">
              Uploading E-Aadhaar Card
            </label>
            {!readMore ? (
              <p className="Aadhar-format-read-more">
                Attach both sides of the E-Aadhaar as a PDF (Max Size: 2MB).{" "}
                <label
                  className="read-more"
                  onClick={() => {
                    setReadMore(true);
                  }}
                >
                  Read more
                </label>
              </p>
            ) : (
              <p className="Aadhar-format-read-more">
                Attach both sides of the E-Aadhaar as a PDF (Max Size: 2MB).
                Download your E-Aadhaar Card from&nbsp;
                <a
                  className="link"
                  onClick={() => {
                    openAadharNewTab();
                  }}
                >
                  uidai.gov.in/en/
                </a>
                &nbsp; website.
              </p>
            )}
          </span>
          <div className="imageSection">
            <img src={combineAadhar} />
          </div>
        </div>

        <div className="aadhar-or-section">
          <img src={borderLine} className="img-section" width={140} />
          <label className="title">OR</label>
          <img src={borderLine} className="img-section" width={140} />
        </div>

        <div className="Aadhar-format-2">
          <span>
            <label className="Aadhar-format-1-title">
              Uploading physical Aadhaar Card
            </label>
            <p className="Aadhar-format-read-more">
              Attach front & back of your physical Aadhaar card in JPEG or PNG
              (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={AadharFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                />
                <div className="badge">1</div>
              </div>

              <label className="Aadhar-Label">FRONT</label>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={AadharBack}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                />
                <div className="badge">2</div>
              </div>

              <label className="Aadhar-Label">BACK</label>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default SampleAadharPopup;
